module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-countdown"
  }, [_c('h1', [_vm._v(_vm._s(_vm._f("twoDigits")(_vm.minutes)) + ":" + _vm._s(_vm._f("twoDigits")(_vm.seconds)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a2b8c3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Countdown.vue
// module id = 639
// module chunks = 1